import CreateImportFile
  from '@/application/import/createImportFile/CreateImportFile';
import ImportFileRepositoryApi from '@/infrastructure/import/ImportFileRepositoryApi';

export default {};

export const createImportFile = new CreateImportFile(
  new ImportFileRepositoryApi(),
);
